import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const H = ({ style, ...p }: React.HTMLAttributes<HTMLElement>) => (
  <span style={{ fontFamily: "'Space Grotesk', sans-serif", ...style }} {...p} />
)

const FAQS = [
  {
    q: 'AI Speaking feedback có chính xác không?',
    a: 'AI của chúng tôi được hiệu chỉnh riêng cho thang điểm VSTEP, đạt tương quan 94% với giám khảo người thật. Phản hồi tức thì về độ trôi chảy, ngữ pháp và phát âm.',
  },
  {
    q: 'Tôi có thể hủy đăng ký bất kỳ lúc nào không?',
    a: 'Có, bạn có thể hủy bất kỳ lúc nào trong cài đặt tài khoản. Bạn vẫn giữ quyền truy cập đến hết chu kỳ thanh toán hiện tại.',
  },
  {
    q: 'Có ưu đãi cho trường học và cơ sở giáo dục không?',
    a: 'Chúng tôi có gói giá theo tầng cho trường học và trung tâm ngoại ngữ. Vui lòng liên hệ đội hỗ trợ để nhận báo giá tùy chỉnh.',
  },
]

const CATEGORIES = [
  { icon: 'payments', label: 'Tài khoản & Thanh toán', desc: 'Quản lý đăng ký, cập nhật phương thức thanh toán và xem lịch sử thanh toán.', color: '#004be2', bg: '#e8eeff' },
  { icon: 'amp_stories', label: 'Tính năng học tập', desc: 'Nắm vững phản hồi AI, hệ thống thẻ từ vựng và bài luyện nói.', color: '#004be2', bg: '#e8eeff' },
  { icon: 'school', label: 'Hướng dẫn thi VSTEP', desc: 'Phân tích đầy đủ định dạng và thang điểm thi VSTEP.', color: '#8e00d5', bg: '#f5e6ff' },
  { icon: 'report_problem', label: 'Vấn đề kỹ thuật', desc: 'Gặp sự cố ghi âm hoặc AI phản hồi chậm? Chúng tôi có giải pháp.', color: '#b41340', bg: '#ffe8ed' },
  { icon: 'forum', label: 'Cộng đồng', desc: 'Tham gia cùng hơn 10.000 học viên đang luyện thi VSTEP.', color: '#006571', bg: '#e6fafb' },
  { icon: 'api', label: 'Developer API', desc: 'Tích hợp EngHustle vào nền tảng học tập của riêng bạn.', color: '#535b71', bg: '#f0f1f5' },
]

/** Help & Support Center */
export default function HelpPage() {
  const navigate = useNavigate()
  const [openFaq, setOpenFaq] = useState<number | null>(0)
  const [search, setSearch] = useState('')

  return (
    <div style={{ minHeight: '100vh', background: '#f6f6ff', fontFamily: "'Manrope', sans-serif", color: '#272e42' }}>
      {/* Nav */}
      <nav style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1.25rem 2rem', background: 'rgba(255,255,255,0.65)', backdropFilter: 'blur(24px)', position: 'sticky', top: 0, zIndex: 10, boxShadow: '0 20px 40px rgba(0,75,226,0.06)' }}>
        <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <div style={{ width: '2.25rem', height: '2.25rem', borderRadius: '0.75rem', background: 'linear-gradient(135deg,#004be2,#809bff)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span className="material-symbols-outlined" style={{ color: 'white', fontSize: '1.25rem', fontVariationSettings: "'FILL' 1" }}>bolt</span>
          </div>
          <H style={{ fontWeight: 800, fontSize: '1.25rem', letterSpacing: '-0.03em', color: '#004be2' }}>EngHustle</H>
        </button>
        <button onClick={() => navigate('/dashboard')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#535b71', fontWeight: 600, fontSize: '0.875rem', display: 'flex', alignItems: 'center', gap: '0.375rem' }}>
          <span className="material-symbols-outlined" style={{ fontSize: '1rem' }}>arrow_back</span>
          Quay lại
        </button>
      </nav>

      <main style={{ maxWidth: '64rem', margin: '0 auto', padding: '4rem 2rem' }}>
        {/* Hero */}
        <div style={{ textAlign: 'center', marginBottom: '4rem', position: 'relative' }}>
          <div style={{ position: 'absolute', top: '-2rem', right: '-4rem', width: '18rem', height: '18rem', background: 'rgba(0,75,226,0.05)', borderRadius: '50%', filter: 'blur(60px)', pointerEvents: 'none' }} />
          <div style={{ position: 'absolute', top: '0', left: '-4rem', width: '12rem', height: '12rem', background: 'rgba(142,0,213,0.05)', borderRadius: '50%', filter: 'blur(50px)', pointerEvents: 'none' }} />

          <H style={{ display: 'block', fontSize: 'clamp(2rem, 5vw, 3.5rem)', fontWeight: 900, letterSpacing: '-0.04em', marginBottom: '1.5rem', lineHeight: 1.1, position: 'relative' }}>
            Chúng tôi có thể giúp gì<br />
            cho <span style={{ background: 'linear-gradient(135deg,#004be2,#8e00d5)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>hành trình</span> của bạn?
          </H>

          {/* Search bar */}
          <div style={{ position: 'relative', maxWidth: '36rem', margin: '0 auto 1.5rem', display: 'flex', alignItems: 'center', background: 'white', borderRadius: '9999px', boxShadow: '0 20px 40px rgba(0,0,0,0.08)', padding: '0.375rem 0.375rem 0.375rem 1.25rem' }}>
            <span className="material-symbols-outlined" style={{ color: '#a5adc6', fontSize: '1.25rem', flexShrink: 0 }}>search</span>
            <input
              type="text"
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Tìm hướng dẫn, lịch thi, hoặc cách đặt lại mật khẩu..."
              style={{ flex: 1, border: 'none', outline: 'none', padding: '0.75rem 0.875rem', fontFamily: "'Manrope', sans-serif", fontSize: '0.9375rem', background: 'transparent', color: '#272e42' }}
            />
            <button style={{ padding: '0.875rem 1.75rem', borderRadius: '9999px', border: 'none', background: 'linear-gradient(135deg,#004be2,#809bff)', color: 'white', fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, cursor: 'pointer', flexShrink: 0 }}>
              Tìm kiếm
            </button>
          </div>

          {/* Popular tags */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.625rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <span style={{ fontSize: '0.8125rem', color: '#535b71', fontWeight: 600 }}>Phổ biến:</span>
            {['Lịch thi VSTEP', 'Đặt lại mật khẩu', 'Mẹo thi Speaking'].map(tag => (
              <button key={tag} style={{ padding: '0.25rem 0.875rem', borderRadius: '9999px', background: '#eef0ff', border: 'none', color: '#004be2', fontWeight: 700, fontSize: '0.8125rem', cursor: 'pointer' }}>{tag}</button>
            ))}
          </div>
        </div>

        {/* Categories bento grid */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1.25rem', marginBottom: '4rem' }}>
          {/* Large card */}
          <div
            style={{ gridColumn: '1 / 3', background: '#eef0ff', borderRadius: '1.75rem', padding: '2.25rem', position: 'relative', overflow: 'hidden', cursor: 'pointer', transition: 'all 0.3s' }}
            onMouseEnter={e => { e.currentTarget.style.background = '#e2e7ff' }}
            onMouseLeave={e => { e.currentTarget.style.background = '#eef0ff' }}
          >
            <div style={{ position: 'absolute', top: '-2rem', right: '-2rem', width: '10rem', height: '10rem', background: 'rgba(0,75,226,0.1)', borderRadius: '50%', pointerEvents: 'none' }} />
            <div style={{ width: '3.5rem', height: '3.5rem', background: 'white', borderRadius: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1.25rem', boxShadow: '0 4px 12px rgba(0,0,0,0.06)' }}>
              <span className="material-symbols-outlined" style={{ color: '#004be2', fontSize: '1.75rem', fontVariationSettings: "'FILL' 1" }}>payments</span>
            </div>
            <H style={{ display: 'block', fontWeight: 800, fontSize: '1.375rem', marginBottom: '0.625rem' }}>Tài khoản & Thanh toán</H>
            <p style={{ color: '#535b71', fontSize: '0.9375rem', lineHeight: 1.6, maxWidth: '24rem', marginBottom: '1.25rem' }}>Quản lý đăng ký, cập nhật phương thức thanh toán và xem lịch sử thanh toán.</p>
            <span style={{ color: '#004be2', fontWeight: 700, fontSize: '0.875rem', display: 'flex', alignItems: 'center', gap: '0.375rem' }}>
              Đến thanh toán <span className="material-symbols-outlined" style={{ fontSize: '1rem' }}>arrow_forward</span>
            </span>
          </div>

          {/* Small cards */}
          {CATEGORIES.slice(1).map(cat => (
            <div
              key={cat.label}
              style={{ background: 'white', borderRadius: '1.75rem', padding: '1.75rem', cursor: 'pointer', transition: 'all 0.2s', boxShadow: '0 4px 16px rgba(0,0,0,0.04)' }}
              onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,0,0,0.1)'; e.currentTarget.style.transform = 'translateY(-2px)' }}
              onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.04)'; e.currentTarget.style.transform = 'none' }}
            >
              <div style={{ width: '3rem', height: '3rem', background: cat.bg, borderRadius: '0.875rem', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '1rem' }}>
                <span className="material-symbols-outlined" style={{ color: cat.color, fontSize: '1.5rem' }}>{cat.icon}</span>
              </div>
              <H style={{ display: 'block', fontWeight: 800, fontSize: '1rem', marginBottom: '0.375rem' }}>{cat.label}</H>
              <p style={{ fontSize: '0.8125rem', color: '#535b71', lineHeight: 1.5 }}>{cat.desc}</p>
            </div>
          ))}
        </div>

        {/* FAQ */}
        <div style={{ background: '#eef0ff', borderRadius: '2rem', padding: '3rem', marginBottom: '3rem' }}>
          <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
            <H style={{ display: 'block', fontWeight: 900, fontSize: 'clamp(1.5rem, 3vw, 2rem)', marginBottom: '0.5rem' }}>Câu hỏi thường gặp</H>
            <p style={{ color: '#535b71', fontSize: '0.9375rem' }}>Mọi điều bạn cần biết về nền tảng và hành trình học.</p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.875rem' }}>
            {FAQS.map((faq, i) => (
              <div key={i} style={{ background: 'white', borderRadius: '1.25rem', overflow: 'hidden' }}>
                <button
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  style={{ width: '100%', padding: '1.25rem 1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left' }}
                >
                  <span style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 700, fontSize: '0.9375rem', color: '#272e42' }}>{faq.q}</span>
                  <span className="material-symbols-outlined" style={{ color: '#004be2', fontSize: '1.25rem', transition: 'transform 0.2s', transform: openFaq === i ? 'rotate(180deg)' : 'none', flexShrink: 0 }}>expand_more</span>
                </button>
                {openFaq === i && (
                  <div style={{ padding: '0 1.5rem 1.25rem', color: '#535b71', fontSize: '0.9375rem', lineHeight: 1.7 }}>{faq.a}</div>
                )}
              </div>
            ))}
          </div>

          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <button style={{ background: 'none', border: 'none', color: '#004be2', fontWeight: 700, cursor: 'pointer', textDecoration: 'underline', fontSize: '0.9375rem' }}>
              Xem toàn bộ tài liệu hướng dẫn
            </button>
          </div>
        </div>

        {/* CTA */}
        <div style={{ background: '#d1dcff', borderRadius: '2rem', padding: '3rem', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', bottom: '-4rem', left: '-4rem', width: '14rem', height: '14rem', background: 'rgba(142,0,213,0.1)', borderRadius: '50%', filter: 'blur(40px)', pointerEvents: 'none' }} />
          <H style={{ display: 'block', fontWeight: 900, fontSize: '1.75rem', marginBottom: '0.75rem', position: 'relative' }}>Vẫn cần trợ giúp?</H>
          <p style={{ color: '#535b71', lineHeight: 1.7, marginBottom: '2rem', position: 'relative' }}>Đội ngũ và AI Tutor của chúng tôi hoạt động 24/7 để hành trình của bạn không bao giờ dừng lại.</p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', position: 'relative', flexWrap: 'wrap' }}>
            <button style={{ padding: '1rem 2.5rem', borderRadius: '9999px', border: 'none', background: 'linear-gradient(135deg,#004be2,#809bff)', color: 'white', fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, cursor: 'pointer', boxShadow: '0 10px 30px rgba(0,75,226,0.3)' }}>
              Liên hệ hỗ trợ
            </button>
            <button onClick={() => navigate('/challenges')} style={{ padding: '1rem 2.5rem', borderRadius: '9999px', border: '2px solid rgba(255,255,255,0.5)', background: 'rgba(255,255,255,0.5)', color: '#272e42', fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, cursor: 'pointer' }}>
              Truy cập diễn đàn
            </button>
          </div>
        </div>
      </main>

      {/* AI chat FAB */}
      <button style={{ position: 'fixed', bottom: '2rem', right: '2rem', background: 'linear-gradient(135deg,#004be2,#809bff)', color: 'white', display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '1rem 1.75rem', borderRadius: '9999px', border: 'none', cursor: 'pointer', boxShadow: '0 20px 40px rgba(0,75,226,0.3)', zIndex: 50 }}>
        <span className="material-symbols-outlined" style={{ fontSize: '1.5rem', fontVariationSettings: "'FILL' 1" }}>smart_toy</span>
        <span style={{ fontFamily: "'Space Grotesk', sans-serif", fontWeight: 700, fontSize: '0.875rem' }}>Chat với AI Tutor</span>
        <div style={{ position: 'absolute', top: '-0.25rem', right: '-0.25rem', width: '1rem', height: '1rem', background: '#22c55e', borderRadius: '50%', border: '3px solid #f6f6ff' }} />
      </button>
    </div>
  )
}
